<template>
  <div class="ec-container">
    <div class="cs-padding ec-container">
      <EcomHeader
        @setSearchInput="setSearchInput"
        @onChangeCategories="
          (id, index) => getProductsByCategoryId(id, index, true)
        "
        :categories="categories"
      />
      <div
        class="grid grid-cols-3 gap-3"
        style="min-height: 40px"
        v-loading="isLoadingVoucher"
        v-if="listVoucher && listVoucher.length"
      >
        <div
          class="voucher-wrapper"
          :style="
            voucherSelected === item.voucher_code_id
              ? 'background: #e4f2fb'
              : ''
          "
          @click="handleSelectVoucher(item)"
          v-for="item in listVoucher"
          :key="item.id"
        >
          <div class="org-logo">
            <img src="/logo.png" alt />
          </div>
          <div class="voucher-info w-100">
            <div class="flex items-center justify-between w-100">
              <p class="mb-1 font-semibold">Mã giảm giá HODO</p>
              <div class="voucher-value mb-1">
                Giảm {{ item.voucher_value }}
              </div>
            </div>
            <p class="mb-1">
              Từ {{ formatDate(item.campaign_start) }} đến
              {{ formatDate(item.campaign_end) }}
            </p>
            <div class="button">Dùng ngay</div>
          </div>
        </div>
      </div>
      <!-- <i
        v-if="isShowVoucher"
        class="el-icon-circle-close icon-close"
        @click="isShowVoucher = false"
      ></i>-->
      <div class="ec-body mt-3">
        <div
          v-if="!appUtils.checkIsMobileAndTablet()"
          class="ec-body-head d-flex items-center overflow-x-auto overflow-y-hidden overflow-hidden--scrollbar whitespace-nowrap py-2"
        >
          <div class></div>
          <div class="d-flex items-center">
            <div
              class="border-b-2 border-solid border-t-0 border-r-0 border-l-0 pb-1 px-2 mr-6"
              :class="`${
                activeCategoryIndex === -1
                  ? 'border-blue-700 text-blue-700'
                  : 'border-transparent'
              }`"
              role="button"
              @click="getProductsByCategoryId(-1, -1, true)"
            >
              <span class="d-inline-block w-6 h-6">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    fill="currentColor"
                    d="M21.5 13.858l0 4.705c0 0-4 1.684-4 1.684 0 0 0-4.704 0-4.704l4-1.685zM16.962 11.543l3.741 1.562c0 0-3.741 1.563-3.741 1.563 0 0-3.682-1.563-3.682-1.563l3.682-1.562zM11.5 13.858l0 4.705c0 0-4 1.684-4 1.684 0 0 0-4.704 0-4.704l4-1.685zM2.5 13.858l4 1.685c0 0 0 4.704 0 4.704 0 0-4-1.684-4-1.684l0-4.705zM6.962 11.543l3.741 1.562c0 0-3.741 1.563-3.741 1.563 0 0-3.682-1.563-3.682-1.563l3.682-1.562zM7.5 5.884l4 1.701c0 0 0 4.764 0 4.764 0 0-4-1.702-4-1.702l0-4.763zM16.5 5.884l0 4.763c0 0-4 1.702-4 1.702 0 0 0-4.764 0-4.764l4-1.701zM11.962 3.543l3.752 1.584c0 0-3.752 1.584-3.752 1.584 0 0-3.693-1.584-3.693-1.584l3.693-1.584zM12.5 13.858l4 1.685c0 0 0 4.704 0 4.704 0 0-4-1.684-4-1.684l0-4.705z"
                  />
                </svg>
              </span>
              <label class="ml-2 cursor-pointer align-middle">Tất cả</label>
            </div>
            <div
              class="border-b-2 border-solid border-t-0 border-r-0 border-l-0 pb-1 px-2"
              :class="`${index < categories.length - 1 ? 'mr-6' : ''} ${
                activeCategoryIndex === index
                  ? 'border-blue-700 text-blue-700'
                  : 'border-transparent'
              }`"
              role="button"
              v-for="(cate, index) in categories"
              :key="`category-${cate.id}-${index}`"
              @click="getProductsByCategoryId(cate.id, index, true)"
            >
              <span
                v-if="cate.icon"
                class="d-inline-block w-6 h-6"
                v-html="cate.icon"
              ></span>
              <label class="ml-2 cursor-pointer align-middle">{{
                cate.name
              }}</label>
            </div>
          </div>
        </div>

        <div v-loading="isLoading" class="pb-3">
          <div v-if="productMap && productMap.length">
            <div
              class="ec-body-list grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4"
            >
              <div
                v-for="(p, index) in productMap"
                :key="`product-${index}-` + p.id"
              >
                <ProductItem
                  :product="p"
                  @clickService="handleClickBuyProduct"
                />
              </div>
            </div>
            <div
              v-if="totalProducts > filters.page_size"
              class="paging flex items-center justify-content-center mt-10"
            >
              <b-pagination
                v-model="filters.page_num"
                :total-rows="totalProducts"
                :per-page="filters.page_size"
                prev-class="prev-item"
                next-class="next-item"
              ></b-pagination>
            </div>
          </div>
          <div v-else class="ec-body-list d-flex justify-center h-96">
            <div class="my-auto text-center">
              <div class="inline-block mb-3 w-32 h-32">
                <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                <path
                  d="M 15.46875 6 C 15.25 6 15.019531 6.085938 14.84375 6.21875 L 4.40625 14.21875 C 4.390625 14.230469 4.359375 14.238281 4.34375 14.25 C 4.328125 14.265625 4.328125 14.265625 4.3125 14.28125 C 4.292969 14.300781 4.265625 14.324219 4.25 14.34375 C 4.210938 14.390625 4.1875 14.449219 4.15625 14.5 C 4.144531 14.519531 4.105469 14.542969 4.09375 14.5625 L 0.09375 22.5625 C -0.0976563 22.949219 -0.0234375 23.414063 0.28125 23.71875 C 0.472656 23.910156 0.742188 24 1 24 C 1.152344 24 1.296875 23.976563 1.4375 23.90625 L 4 22.625 L 4 43 C 4 43.554688 4.449219 44 5 44 L 35 44 C 35.148438 44 35.28125 43.964844 35.40625 43.90625 C 35.441406 43.890625 35.46875 43.863281 35.5 43.84375 C 35.589844 43.789063 35.683594 43.734375 35.75 43.65625 C 35.761719 43.644531 35.769531 43.636719 35.78125 43.625 L 43.78125 33.625 C 43.921875 33.445313 44 33.226563 44 33 L 44 26.28125 L 41.09375 29.3125 C 40.902344 29.511719 40.648438 29.625 40.375 29.625 C 40.339844 29.625 40.285156 29.628906 40.25 29.625 C 39.9375 29.589844 39.660156 29.394531 39.5 29.125 L 34 19.90625 L 34 42 L 6 42 L 6 16 L 34 16 L 40.53125 26.96875 L 49.71875 17.71875 C 50.042969 17.394531 50.082031 16.894531 49.84375 16.5 L 43.84375 6.5 C 43.835938 6.484375 43.824219 6.453125 43.8125 6.4375 C 43.785156 6.390625 43.753906 6.351563 43.71875 6.3125 C 43.710938 6.304688 43.726563 6.289063 43.71875 6.28125 C 43.703125 6.265625 43.671875 6.265625 43.65625 6.25 C 43.621094 6.21875 43.601563 6.183594 43.5625 6.15625 C 43.554688 6.152344 43.539063 6.160156 43.53125 6.15625 C 43.5 6.136719 43.46875 6.109375 43.4375 6.09375 C 43.40625 6.078125 43.375 6.074219 43.34375 6.0625 C 43.289063 6.042969 43.246094 6.042969 43.1875 6.03125 C 43.167969 6.027344 43.144531 6.003906 43.125 6 C 43.109375 5.996094 43.078125 6.003906 43.0625 6 C 43.035156 6 43.027344 6 43 6 Z M 15.8125 8 L 40.59375 8 L 34.59375 14 L 7.96875 14 Z M 15 20 C 14.449219 20 14 20.449219 14 21 C 14 21.550781 14.449219 22 15 22 L 25 22 C 25.550781 22 26 21.550781 26 21 C 26 20.449219 25.550781 20 25 20 Z"
                />
                </svg>-->
                <img
                  src="../../../public/images/Page/empty.png"
                  class="img-fluid mb-3"
                  alt
                />
              </div>
              <div class="text-center fs-20" v-if="filters.q">
                <span class="mr-1">Không tìm thấy dữ liệu cho từ khóa</span>
                <strong>"{{ filters.q }}"</strong>
              </div>
              <div class="text-center fs-20" v-else>
                <span>Không có dữ liệu</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalConfirmRequirePaper
      ref="modalConfirmRequire"
      @confirm="confirmRequiredPaper"
    />
  </div>
</template>

<script>
import ProductItem from '../../components/Ecom/ProductItem.vue'
import { BPagination } from 'bootstrap-vue'
import store from '@/store'
import appUtils from '../../utils/appUtils'
import EcomHeader from '../../components/Ecom/Header.vue'
import ModalConfirmRequirePaper from '../../pages/Ecom/detail/ModalConfirmRequirePaper.vue'
import { PRODUCT_TYPE } from '@/utils/constant'
import { mixinQueryParams } from '@/utils/mixinQueryParams'
import { mapState } from 'vuex'

export default {
  name: 'ProductList',
  components: {
    EcomHeader,
    BPagination,
    ProductItem,
    ModalConfirmRequirePaper
  },
  mixins: [mixinQueryParams],
  data: function () {
    return {
      isLoading: true,
      appUtils,
      products: [],
      productMap: [],
      categories: [],
      filters: {
        keyword: '',
        page_num: 1,
        page_size: 15,
        order: 'desc',
        sort_by: 'cate_id'
      },
      totalProducts: 0,
      activeCategoryIndex: -1,
      activeCategoryId: -1,
      PRODUCT_TYPE,
      isShowVoucher: true,
      isLoadingVoucher: false,
      voucherSelected: ''
    }
  },
  async created () {
    const query = this.$route.query

    if (query?.search) {
      this.setSearchInput(query?.search)
    }

    await this.fetchCategories()
    await this.getProductsByCategoryWithRoute()
    if (this.$user?.id) {
      await this.getListVoucher()
    }
    this.voucherSelected = +this.$route.query?.voucher_code_id
  },
  watch: {
    $route: {
      async handler (data) {
        if (data.query?.search) {
          this.filters.page_num = 1
          this.setSearchInput(data.query?.search)
        }
        if (data.query?.type) {
          this.filters.page_num = 1
          await this.getProductsByCategoryWithRoute()
        } else {
          this.filters.page_num = 1
          await this.fetchProducts()
        }
      },
      deep: true
    },
    filters: {
      handler (value) {
        if (this.activeCategoryIndex >= 0 && this.activeCategoryId > 0) {
          this.fetchProducts(this.activeCategoryId)
          return
        }
        this.fetchProducts()
      },
      deep: true
    },
    products () {
      this.productMap = this.products?.map((elm) => {
        return {
          ...elm,
          selected_variant:
            elm.product_variants?.find((elm) => elm.is_default === 2) ||
            elm.product_variants?.find((elm) => elm.conversion_rate === 1) ||
            elm.product_variants[0],
          variant_id:
            elm.product_variants?.find((elm) => elm.is_default === 2)?.id ||
            elm.product_variants?.find((elm) => elm.conversion_rate === 1)
              ?.id ||
            elm.product_variants[0]?.id
        }
      })
    }
  },
  computed: {
    ...mapState('ecommerce', ['listVoucher'])
  },
  methods: {
    async getProductsByCategoryWithRoute () {
      const query = this.$route.query
      if (!this.categories?.length) {
        await this.fetchCategories()
      }

      const cates = this.categories?.map((cate) =>
        appUtils.slugifyStr(cate?.name)
      )

      if (query?.type) {
        const cateIndex = cates?.findIndex((item) => item === query?.type)

        if (cateIndex === -1 || typeof cateIndex === 'undefined') {
          this.getProductsByCategoryId(-1, -1)
        } else {
          this.getProductsByCategoryId(
            this.categories[cateIndex]?.id,
            cateIndex
          )
        }
      } else {
        this.getProductsByCategoryId(-1, -1)
      }
    },
    handleClickBuyProduct (product) {
      const payload = {
        product: product,
        requireForms: product.order_form_config?.order_form_items
      }
      this.$refs.modalConfirmRequire.showModalConfirm(true, payload)
    },
    confirmRequiredPaper (payload) {
      if (payload.product.type === PRODUCT_TYPE.PRODUCT) {
        appUtils.addToCart(payload.product)
        window.$toast.open({
          message: this.$t('Thêm vào giỏ hàng thành công'),
          type: 'success'
        })
      } else {
        appUtils.addToCart(payload.product)
        window.$toast.open({
          message: this.$t('Thêm vào giỏ hàng thành công'),
          type: 'success'
        })

        // if (!this.$user) {
        //   this.$targetRoute = '/#/shopping-cart'
        //   this.$router.push({ name: 'Login' })
        //   return false
        // }

        // try {
        //   this.$router
        //     .push({
        //       name: 'OrderConfirm'
        //     })
        //     .catch((_) => {})
        // } catch (error) {
        //   console.log(error)
        // }
      }
    },
    setSearchInput (value) {
      this.filters.keyword = value
    },
    async fetchProducts (category_id) {
      this.isLoading = true
      const params = {
        ...this.filters,
        category_id,
        is_public: 2
      }
      if (this.$route.query?.voucher_code_id) {
        params.voucher_id = this.$route.query?.voucher_code_id
      }
      await store
        .dispatch('ecommerce/fetchProducts', params)
        .then((res) => {
          this.products = res.data.data
          this.totalProducts = res.data.page?.total
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => (this.isLoading = false))
    },
    async fetchCategories () {
      this.isLoading = true
      const { keyword, ...newFilters } = this.filters

      await store
        .dispatch('ecommerce/fetchCategories', {
          ...newFilters,
          sort_by: 'id',
          order: 'asc'
        })
        .then((res) => {
          this.categories = res.data?.data
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => (this.isLoading = false))
    },
    getProductsByCategoryId (categoryId, index, isHandleCurrentTab) {
      if (!categoryId) return

      const cateData = this.categories[index]

      this.activeCategoryIndex = index
      this.activeCategoryId = categoryId

      if (categoryId === -1) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              type: ''
            }
          })
          .catch((_) => {})
      } else {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              type: appUtils.slugifyStr(cateData?.name)
            }
          })
          .catch((_) => {})
      }

      if (isHandleCurrentTab) return

      if (categoryId === -1) {
        this.fetchProducts()
        return
      }
      this.fetchProducts(categoryId)
    },
    async handleSelectVoucher (item) {
      if (item.voucher_code_id === this.voucherSelected) {
        this.voucherSelected = ''
        this.handleSetFilter({ voucher_code_id: this.voucherSelected })
        this.$store.commit(
          'ecommerce/SET_VOUCHER_SELECTED',
          this.voucherSelected
        )
      } else {
        this.voucherSelected = item.voucher_code_id
        this.handleSetFilter({ voucher_code_id: this.voucherSelected })
        this.$store.commit(
          'ecommerce/SET_VOUCHER_SELECTED',
          item.voucher_code_id
        )
      }
    },
    async getListVoucher () {
      try {
        this.isLoadingVoucher = true
        await this.$store.dispatch('ecommerce/getListVoucher', {
          user_id: this.$user?.id
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoadingVoucher = false
      }
    },
    formatDate (date) {
      return window.moment(Date(date)).format('DD/MM/YYYY')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .ec-container {
    background: rgba(247, 247, 249, 1);
    padding-top: 32px;
  }
  .ec-header {
    display: flex;
  }
  .search-wraper {
    width: calc(100% - 300px);
  }

  .el-input__inner {
    border: 2px solid rgba(213, 210, 249, 1);
    height: 50px;
    border-radius: 67px;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 45px;
  }
  .el-input__suffix {
    right: 18px;
  }
  .button-shopping {
    height: 50px;
    width: 125px;
    border-radius: 9px;
    padding: 6px 12px 6px 12px;
  }
  //products
  .product-item {
    width: 100%;
    background-color: #fff !important;
    border-radius: 16px;
    transition: all 0.3s ease;
    &:hover {
      box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.15);
      transform: scale(1.02);
    }
  }
  .product-item-img {
    height: 140px;
    object-fit: contain;
    margin-bottom: 8px;
  }
  .product-item-name {
    height: 48px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 8px;
  }
  .product-item-sale-price,
  .product-item-price,
  .ec-body-head,
  .ec-body-list {
    margin-bottom: 16px;
  }
  .add-to-cart-btn {
    height: 52px;
    width: 100%;
    border-radius: 12px;
    padding: 8px 12px 8px 12px;
    background: rgba(71, 109, 214, 1);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .add-to-cart-btn:disabled {
    background: rgba(173, 173, 173, 1);
  }
  .el-pager .number,
  .el-pagination .btn-next i,
  .el-pagination .btn-prev i {
    font-size: 16px !important;
  }
  .el-pager li,
  .el-pagination .btn-next,
  .el-pagination .btn-prev {
    height: 45px;
    padding: 8.5px 4px;
  }

  .cs-padding {
    padding-left: 60px;
    padding-right: 60px;
  }
  .voucher-wrapper {
    cursor: pointer;
    border: 1px solid #dbdbdb;
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: 12px 16px;
    gap: 12px;
    background: #fff;
    .org-logo {
      padding-right: 16px;
      border-right: 1px solid #dbdbdb;
      height: 100%;
      display: flex;
      align-items: center;
    }
    .voucher-info {
      .voucher-value {
        padding: 4px 8px;
        background-image: linear-gradient(180deg, #5c90dd, #1509b5);
        color: #fff;
        font-weight: 600;
        width: fit-content;
        border-radius: 4px;
        font-size: 16px;
        line-height: 24px;
      }
      .button {
        padding: 4px 8px;
        border-radius: 4px;
        background: #20419b;
        color: #fff;
        width: fit-content;
        transition: all ease-in-out 0.2s;
        &:hover {
          // opacity: 0.8;
          cursor: pointer;
          transform: scale(1.05);
        }
      }
    }
  }
  .icon-close {
    font-size: 28px;
    position: absolute;
    top: 151px;
    right: 64px;
    cursor: pointer;
    transition: all ease-in-out 0.1s;
    &:hover {
      scale: 1.1;
    }
  }

  @media (max-width: 765px) {
    .search-wraper {
      width: 100%;
    }
    .cart-wraper {
      margin-left: auto;
    }

    .cs-padding {
      padding: 10px 20px;
    }
  }
}
</style>
